import { TableColumn } from "./dataInterface";

export const outsideEntrySiteTableColumn: TableColumn = {
  title: "外部ETサイト一覧",
  detail: true,
  detailTitle: "外部ETサイト詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "外部ETサイト登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "公開・非公開",
      width: "90px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "category_name",
      name: "カテゴリ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "category",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "site_path",
      name: "サイトパス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: null,
      detail: true,
      edit: false,
      editId: "",
      add: true,
      addType: "text",
      addMessage:
        "※スラッシュ(/)、コンマ(,)、ピリオド(.)不可\n※例：入力値「sample」 → URL「https://quickpass.jp/sample」",
    },
    {
      key: "site_status",
      name: "状態",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text_chip",
      serch: true,
      serchType: "list",
      editType: null,
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "site_color",
      name: "サイトカラー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "※サイトのベースとなるカラーを設定できます。",
    },
    {
      key: "site_layout",
      name: "サイトレイアウト",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "※サイトのベースとなるレイアウトを設定できます。",
    },
    {
      key: "site_title",
      name: "サイトタイトル",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "site_footer",
      name: "フッター情報",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "text",
      addMessage:
        "※空欄の場合、非表示になります\n例：Copyright(c) 2025 Sample inc. ,All rights reserved",
    },
    {
      key: "site_logo",
      name: "サイトロゴ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "outside_site_logo",
      serch: false,
      serchType: null,
      editType: "outside_site_logo",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "outside_site_logo",
      addMessage: "",
    },
    {
      key: "site_favicon",
      name: "favicon",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "outside_site_favicon",
      serch: false,
      serchType: null,
      editType: "outside_site_favicon",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "outside_site_favicon",
      addMessage: "",
    },
    {
      key: "service_page_url",
      name: "サービスページURL",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "text",
      addMessage:
        "※エントリー完了後、画面遷移するページになります。 \n例：https://sample.jp",
    },
    {
      key: "outside_cancell_form",
      name: "解約フォームの設定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "outside_cancell_form_text",
      name: "解約フォームコメント",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "multitext",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "multitext",
      addMessage:
        "※解約ボタンの下部に挿入されます。\n※空欄の場合、非表示になります\n例：カスタマーデスク\n0120-XXX-XXX［営業時間10:00-18:00(平日のみ)］",
    },
    {
      key: "outside_cancell_form_mail_address",
      name: "解約通知予定メールアドレス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "text",
      addMessage:
        "※解約完了後に通知を送るメールアドレスを入力してください。\n迷惑メールフィルターを解除する文言をサイトに表示します。\n※例：入力「info@sample.com」\n表示イメージ「info@sample.comを迷惑メール設定から外して頂けますようお願いいたします。」",
    },
    {
      key: "outside_cancell_url",
      name: "解約用URL",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: false,
      editId: "id",
      add: false,
      addType: "text",
      addMessage: "",
    },
    {
      key: "outside_payment",
      name: "独自決済の設定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: null,
      detail: true,
      edit: false,
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "outside_entry_url",
      name: "外部ET用URL",
      tableDetailAuth: ["パートナー", "営業アカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: false,
      editId: "id",
      add: false,
      addType: "text",
      addMessage: "",
    },
    {
      key: "outside_cancell_url",
      name: "解約用URL",
      tableDetailAuth: ["パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "text",
      detail: true,
      edit: false,
      editId: "id",
      add: false,
      addType: "text",
      addMessage: "",
    },
  ],
  spTier: 'sp_first',
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "PDF一覧",
      subTableColumnLength: "pdf_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: true,
      subTableDetailTitle: "PDF詳細",
      subTableAdd: true,
      subTableAddTitle: "PDF追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: true,
      subTableEditTitle: "PDF編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_site_id",
          name: "外部サイトID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "outside_entry_site_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "site_pdf_name",
          name: "PDF表記名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "サイトに表示される名称になります。　例：利用規約",
        },
        {
          key: "site_pdf_path",
          name: "PDF",
          table: false,
          tableValue: "site_pdf_path",
          detail: true,
          edit: true,
          editType: "site_pdf_path",
          editId: "id",
          add: true,
          addType: "site_pdf_path",
          addMessage: "",
        },
        {
          key: "site_pdf_agree",
          name: "同意有無",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage:
            "PDFファイルに同意するかどうかのチェックボックスを用意します。　例：規約PDFなど",
        },
        {
          key: "site_pdf_footer",
          name: "フッター表示有無",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "PDFファイルをフッターに表示するかどうかを選択可能です。",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "解約チャットアプリ連携一覧",
      subTableColumnLength: "cancell_chat_app_length",
      subTableColumnNameWidth: "185px",
      detailKey: ["id"],
      subTableDetail: true,
      subTableDetailTitle: "解約チャットアプリ連携詳細",
      subTableAdd: true,
      subTableAddTitle: "解約チャットアプリ連携追加",
      subTableAddTitleWidth: "185px",
      subTableEdit: true,
      subTableEditTitle: "解約チャットアプリ連携編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_site_id",
          name: "外部サイトID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "cancell_sns_type",
          name: "チャットアプリ連携タイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "cancell_sns_id",
          name: "チャットアプリ連携ID",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "cancell_sns_haeder",
          name: "チャットアプリ連携時ヘッダー",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※末尾に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
        {
          key: "cancell_sns_footer",
          name: "チャットアプリ連携時フッター",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※先頭に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "独自決済一覧",
      subTableColumnLength: "payment_method_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "独自決済詳細",
      subTableAdd: false,
      subTableAddTitle: "独自決済追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "独自決済編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "payment_company",
          name: "決済会社",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_method",
          name: "決済方法",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_method_name",
          name: "決済方法_サイト表示名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      subTableColumnName: "アカウント一覧",
      subTableColumnLength: "entry_account_length",
      subTableColumnNameWidth: "100px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "アカウント詳細",
      subTableAdd: false,
      subTableAddTitle: "アカウント追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "アカウント編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "entry_sale_company_group_name",
          name: "グループ",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "entry_sale_account_name",
          name: "アカウント名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "entry_url",
          name: "エントリーURL",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
